import {Spinner} from '@chakra-ui/react';
import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/input';

interface AmountInputProps {
  amountInput: {value: string};
  loading: boolean;
  currency?: string;
  currencyPostfix?: string;
  setAutoFocus?: boolean;
}

export const AmountInput = ({
  amountInput,
  loading,
  currency,
  currencyPostfix,
  setAutoFocus,
}: AmountInputProps): React.ReactElement => {
  return (
    <InputGroup>
      <InputLeftElement
        ml={currencyPostfix ? 4 : 2}
        pointerEvents="none"
        textStyle="h6"
        color="midGrey"
        fontWeight="500"
        fontSize="18px"
        alignSelf="center"
        height="100%"
      >
        {currencyPostfix}
        {currency}
      </InputLeftElement>

      <Input
        pl={currencyPostfix ? '60px' : ''}
        type="number"
        height="64px"
        textAlign="left"
        textStyle="h6"
        color="midGrey"
        fontWeight="500"
        variant="copper"
        opacity={1}
        borderColor="tone2"
        borderWidth="1px"
        borderRadius="14px"
        autoFocus={setAutoFocus || false}
        {...amountInput}
      />

      {loading ? (
        <InputRightElement alignSelf="center" height="100%" mr={2}>
          <Spinner
            speed="0.65s"
            emptyColor="gray.200"
            color="stampRed"
            size="lg"
          />
        </InputRightElement>
      ) : null}
    </InputGroup>
  );
};
